/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Modal from "react-bootstrap/Modal"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  Badge,
  // Badge
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as leadMetricsAction from "../../store/bGVhZE1ldHJpY3M/actions"
import { isEmpty } from "lodash"
import * as salesAction from "../../store/c2FsZXM/actions"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
// import { get } from "lodash"
// import { toast } from "react-toastify"
import { CSVExport } from "react-bootstrap-table2-toolkit"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import loadertable from "../../assets/images/loader-table.gif"

const LeadMetrics = (props) => {
  const title = "New Lead Metrics"

  const { dispatch, searchBarStyle } = props
  const specificDispatch = useDispatch()

  const { SearchBar } = Search

  //download feature in data table
  const { ExportCSVButton } = CSVExport

  useEffect(() => {
    dispatch(leadMetricsAction.loadRecordsMetaData())
    dispatch(leadMetricsAction.loadLeadMetrics())
    dispatch(salesAction.loadEmployee())
    setApplyFilter(false)
  }, [])

  const [pageLoading, setPageLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false)
    }, 2000)
  }, [1])
  const update = useSelector((specificstate) => specificstate)
  console.log("update is", update)

  const salesUpdate = useSelector((specificstate) => specificstate.sales)
  const leadUpdate = useSelector((specificstate) => specificstate.leadMetrics)
  const { employee_list = [] } = salesUpdate
  const { leadMetricsMetaData = {}, lead_metrics = [] } = leadUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  console.log(lead_metrics.branchName)
  console.log("leadData is", leadUpdate)
  const [btnLoader, setBtnLoader] = useState(false)
  const [leadData, setLeadData] = useState({
    company: [],
    branch: [],
    department: [],
    salesAgent: [],
    fromDate: "",
    toDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [leadSource, setLeadSource] = useState([])
  const [leadStatus, setLeadStatus] = useState([])
  const [salesAgent, setSalesAgent] = useState([])

  const [followupView, setFollowupView] = useState(false)
  const [followupDetails, setFollowupDetails] = useState("")
  const [eventView, setEventView] = useState(false)
  const [eventDetails, setEventDetails] = useState("")

  const handleEventClose = () => setEventView(false)
  const handleFollowupClose = () => setFollowupView(false)

  //dropdown options api
  const branchOptions =
    !isEmpty(leadMetricsMetaData) &&
    leadMetricsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //Employee list
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.empCode = element.empCode
        obj.label = labelEmployee
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  // const employeeOptions = createOptions(employeeList)
  //checking
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const startDate = leadData.fromDate
  const endDate = leadData.toDate

  console.log(company, branch, startDate, endDate, "dropdown outputs")

  const handleChange = async (e) => {
    setLeadData({ ...leadData, [e.target.name]: e.target.value })
  }
  const [applyFilter, setApplyFilter] = useState(false)

  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEmpCode = salesAgent && salesAgent.value ? salesAgent.value : ""
    var searchStatus = leadStatus && leadStatus ? leadStatus.statusId : ""
    var searchSource = leadSource && leadSource ? leadSource.value : ""
    var searchFromDate =
      leadData && leadData.fromDate
        ? moment(leadData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      leadData && leadData.toDate
        ? moment(leadData.toDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEmpCode) {
      searchvalue.agent = searchEmpCode
    }
    if (searchStatus) {
      searchvalue.leadStatus = searchStatus
    }
    if (searchSource) {
      searchvalue.leadSource = searchSource
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }

    console.log("searchCompany", searchvalue)
    specificDispatch(leadMetricsAction.loadLeadMetrics(searchvalue))
    setBtnLoader(true)
    setApplyFilter(true)
    setPageLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setPageLoading(false)
    }, 2000)
  }
  const today = moment().format("YYYY-MM-DD")

  console.log()
  //reset functionalities
  const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setLeadStatus([])
    setSalesAgent([])
    setLeadSource([])
    setLeadData({
      fromDate: today,
      toDate: today,
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      leadMetricsAction.loadLeadMetrics({
        fromDate: today,
        toDate: today,
      })
    )
  }
  // const [approvedData, setApprovedData] = useState("")

  let slNo = 0
  const followupDataTable = !isEmpty(lead_metrics)
    ? lead_metrics.map((leadData, index) => {
      slNo = slNo + 1

      // const dateFormate =
      //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

      var leadAssignDateTime = !isEmpty(leadData.leadAssignDateTime)
        ? moment(leadData.leadAssignDateTime)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : ""
      var currentFollowupDateTime = !isEmpty(leadData.currentFollowupDateTime)
        ? moment(leadData.currentFollowupDateTime)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : ""
      const colorCode =
        !isEmpty(leadMetricsMetaData) &&
        leadMetricsMetaData.processStatusOptions &&
        leadMetricsMetaData.processStatusOptions.length > 0 &&
        leadMetricsMetaData.processStatusOptions.find(
          (_) => _.processStatusId === leadData.processStatus
        ) &&
        leadMetricsMetaData.processStatusOptions.find(
          (_) => _.processStatusId === leadData.processStatus
        ).colorCode
      console.log(colorCode, "colorCode")


      // aging and reassign difference 
      const currentDay = moment().startOf('day')
      const createdDate = moment.utc(leadData.leadCreatedAt).startOf('day')
      const assignedDate = moment.utc(leadData.leadAssignDateTime).startOf('day')

      const createdDifference =
      currentDay&&createdDate
        ?  currentDay.isValid() && createdDate.isValid()
          ?  Math.ceil(currentDay.diff(createdDate, 'days', true))
          : "--"
        : "--"
     const assignDifference =
      currentDay&&assignedDate
        ?  currentDay.isValid() && assignedDate.isValid()
          ?  Math.ceil(currentDay.diff(assignedDate, "days", true))
          : "--"
        : "--"
      const dayDiffValue =  `${createdDifference}/${assignDifference} days`

      return {
        _id: leadData._id,
        sNo: slNo,
        clientName: leadData.clientName,
        action: (
          <Button
            type="submit"
            style={{ fontSize: "10px" }}
            className="btn btn-success buttons"
          >
            <i className="fas fa-pen icon-btn"></i>
          </Button>
        ),
        branchId: leadData.branchId,
        salesUrge: leadData.salesUrge,
        companyName: leadData.companyName,
        branchName: leadData.branchName,
        leadSource: leadData.leadSourceName,
        leadAssign: leadData.leadAssignedName,
        leadAssignDate: leadAssignDateTime,
        followupActionDate: !isEmpty(currentFollowupDateTime)
          ? currentFollowupDateTime
          : "--",
        duration: !isEmpty(leadData.followupDiffDays)
          ? leadData.followupDiffDays
          : "--",
        leadNo: leadData.leadNo,
        leadStatus: leadData.processStatusName,
        colorCode: colorCode,
        quoteGiven: leadData.quotationGiven,
        quoteCode: leadData.quoteCode,
        budget: leadData.budget,
        quoteRevise: leadData.quoteRevise,
        enquiryDate: leadData.enquiryDate,
        isQuotation: leadData.isQuotation === 0 ? "NO" : "YES",
        eventDate: (
          <Badge
            className={`font-size-12 badge rounded-pill 
                bg-info badge-soft-info
            `}
            pill
            onClick={() => {
              setEventView(true)
              setEventDetails(leadData.eventDetails)
            }}
            style={{ padding: "8px" }}
          >
            View
          </Badge>
        ),
        followUp: (
          <div className="d-flex flex-row justify-content-center">
            <p style={{ fontSize: "12px", marginTop: "6px" }}>
              {leadData.currentFollowupCount}
            </p>
            <i
              className="fas fa-eye icon-btn mx-3"
              style={{ fontSize: "16px", color: "#3498db", marginTop: "6px" }}
              onClick={() => {
                setFollowupView(true)
                setFollowupDetails(leadData.CurrentFollowupDetails)
              }}
            ></i>
            {/* </Button> */}
          </div>
        ),
        remarks: leadData.remarks,
        fileName: (
          <a onClick={() => window.open(leadData.rejectAttachment, "_blank")}>
            <span
              style={{
                textDecoration: "underline",
                color: "#E40D8C",
              }}
            >
              View Attachments
            </span>
          </a>
        ),
        leadDate: leadData.leadDate
          ? moment(leadData.leadDate).format("DD-MM-YYYY hh:mm A")
          : [],
        agingDate: dayDiffValue,
        //agingDate:leadData.agingDate?moment(leadData.agingDate).format(dateFormate):"--",
        key: index,
      }
    })
    : []
  //pagination table data columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      style: {
        textTransform: "uppercase",
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "leadAssign",
      text: "Sales Agent",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadStatus",
      text: "Lead Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "5px 6px",
              borderRadius: "4px",
            }}
          >
            {!isEmpty(row.leadStatus) ? row.leadStatus : ""}
          </button>
        )
      },
      headerStyle: {
        minWidth: "188px",
      },
    },
    {
      dataField: "isQuotation",
      text: "Quote Sent",
      sort: true,
      style: {
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "leadSource",
      text: "Lead Source",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadAssignDate",
      text: "Lead Assigned Date & Time",
      sort: true,
      headerStyle: {
        minWidth: "230px",
      },
    },
    {
      dataField: "followupActionDate",
      text: "Followup Action Date & Time",
      sort: true,
      headerStyle: {
        minWidth: "235px",
      },
    },
    // Aging Date / Re-assigning
    {
      dataField: "agingDate",
      text: "Aging/Re-assigning",
      sort: true,
      headerStyle: {
        minWidth: "250px",
      },
    },
    {
      dataField: "duration",
      text: "Lead Aging",
      sort: true,
      headerStyle: {
        minWidth: "296px",
      },
    },
  ]

  const options = {
    sizePerPage: 100,
    totalSize: lead_metrics.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  console.log(today, "today")
  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setLeadData({
          ...leadData,
          fromDate: today,
          toDate: today,
        })
      }
    }, 3000)
  }, [applyFilter])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            leadMetricsMetaData
                              ? leadMetricsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className={"form-label"}>{"Sales Agent"}</Label>

                        <ReactSearchAutocomplete
                          key={resetManager}
                          name="salesAgent"
                          items={employeeOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Status"}
                          </Label>
                        </div>
                        <Select
                          name="leadStatus"
                          value={leadStatus}
                          onChange={(e) => setLeadStatus(e)}
                          options={
                            leadMetricsMetaData
                              ? leadMetricsMetaData.processStatusOptions
                              : []
                          }
                          placeholder="Select Lead Status"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Lead Source"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="leadSource"
                          value={leadSource}
                          onChange={(e) => setLeadSource(e)}
                          options={
                            leadMetricsMetaData
                              ? leadMetricsMetaData.sourceOptions
                              : []
                          }
                          placeholder="Select Lead Source"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Lead From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={leadData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Lead To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={leadData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  {pageLoading ? (
                    <div className="d-flex flex-column">
                      <Col className="mb-3 search-bar">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div
                            className="position-relative mt-3"
                            style={searchBarStyle || null}
                          >
                            <SearchBar />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col md="12" xl="12" lg="12">
                        {/* <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                    </p> */}
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th style={{ minWidth: "150px" }}>Lead No</th>
                              <th style={{ minWidth: "150px" }}>Client Name</th>
                              <th style={{ minWidth: "150px" }}>Company</th>
                              <th style={{ minWidth: "150px" }}>Branch</th>
                              <th style={{ minWidth: "150px" }}>Sales Agent</th>
                              <th style={{ minWidth: "150px" }}>Lead Status</th>
                              <th style={{ minWidth: "150px" }}>Quote Sent</th>
                              <th style={{ minWidth: "150px" }}>Lead Source</th>
                              <th style={{ minWidth: "212px" }}>
                                Lead Assigned Date & Time
                              </th>
                              <th style={{ minWidth: "212px" }}>
                                Followup Action Date & Time
                              </th>
                              <th style={{ minWidth: "212px" }}>
                                Different Duration(Days)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="19">
                                <img
                                  src={loadertable}
                                  style={{ width: "100%", height: "230px" }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            {/* <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              Showing rows 0 to 0 of 0
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <PaginationProvider
                      pagination={paginationFactory(options)}
                      keyField="_id"
                      columns={columns}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={followupDataTable}
                          columns={columns}
                          search
                        >
                          {(props) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row">
                                  <Col className="mb-3">
                                    <div className="d-flex flex-row">
                                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <div
                                          className="position-relative mt-7"
                                          style={searchBarStyle || null}
                                        >
                                          <SearchBar {...props.searchProps} />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </Col>
                                  <Col>
                                    <ExportCSVButton
                                      className="border float-right mx-10"
                                      style={{
                                        float: "right",
                                        backgroundColor: "#e40d8c",
                                        color: "#ffffff",
                                      }}
                                      {...props.csvProps}
                                    >
                                      Download{" "}
                                    </ExportCSVButton>
                                  </Col>
                                  <Col>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      responsive
                                      striped={true}
                                      bordered={true}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {followupView && (
          <Modal show={followupView} size="lg" onHide={handleFollowupClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>FOLLOWUP DETAILS</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "109px" }}>Followup No</th>
                          <th style={{ minWidth: "110px" }}>Followup Date</th>
                          <th style={{ minWidth: "110px" }}>Followup Time</th>
                          <th style={{ minWidth: "170px" }}>Attchments</th>
                          <th style={{ minWidth: "60px" }}>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {followupDetails && followupDetails.length > 0 ? (
                          followupDetails.map((followup, index) => {
                            // let slNo = 0
                            console.log(
                              followup,
                              "request from data table leave"
                            )

                            const attachments =
                              followup.recordAttachment &&
                              followup.recordAttachment.map((record) =>
                                record.split(".").pop()
                              )
                            // var extension = attachments.split('.').pop()
                            console.log(
                              attachments,
                              "attachment from followup details"
                            )
                            // console.log(
                            //   extension,
                            //   "extension followup details"
                            // )
                            // var filename = attachments.substr(attachments.lastIndexOf(".")+1)
                            // console.log(
                            //   filename,
                            //   "extension from followup details"
                            // )
                            return (
                              <tr key={followup._id}>
                                <td>{index + 1}</td>
                                <td>{followup.followupNo}</td>
                                <td style={{ minWidth: "110px" }}>
                                  {!isEmpty(followup.followupDate)
                                    ? moment(followup.followupDate).format(
                                      "DD-MM-YYYY"
                                    )
                                    : followup.followupDate}
                                </td>
                                <td style={{ minWidth: "110px" }}>
                                  {followup.followupTime}
                                </td>
                                <td>
                                  {(followup.recordAttachment.length > 0 &&
                                    attachments[0] === "jpeg") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "jpg") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "png") ? (
                                    <a
                                      onClick={() =>
                                        window.open(
                                          followup.recordAttachment,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                          color: "#E40D8C",
                                        }}
                                      >
                                        View
                                      </span>
                                    </a>
                                  ) : (followup.recordAttachment.length > 0 &&
                                    attachments[0] === "mp3") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "m4a") ||
                                    (followup.recordAttachment.length > 0 &&
                                      attachments[0] === "mp4") ? (
                                    <a href={followup.recordAttachment}>
                                      <audio controls>
                                        <source
                                          src={followup.recordAttachment}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td>{followup.remarks}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={6} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setFollowupView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {eventView && (
          <Modal show={eventView} size="lg" onHide={handleEventClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <div className="d-flex flex-row">
                <span>EVENT DETAILS</span>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "109px" }}>Event No</th>
                          <th style={{ minWidth: "110px" }}>Event Name</th>
                          <th style={{ minWidth: "110px" }}>Event Date</th>
                          <th style={{ minWidth: "110px" }}>Start Time</th>
                          <th style={{ minWidth: "110px" }}>End Time</th>
                          <th style={{ minWidth: "170px" }}>Venue Location</th>
                          <th style={{ minWidth: "60px" }}>Venue Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {eventDetails.length > 0 ? (
                          eventDetails.map((event, index) => {
                            // let slNo = 0
                            console.log(event, "request from data table leave")

                            return (
                              <tr key={event._id}>
                                <td>{index + 1}</td>
                                <td>{event.eventNo}</td>
                                <td>{event.eventName}</td>
                                <td>
                                  {!isEmpty(event.eventDate)
                                    ? moment(event.eventDate).format(
                                      "DD-MM-YYYY"
                                    )
                                    : event.eventDate}
                                </td>
                                <td>{event.startTime}</td>
                                <td>{event.endTime}</td>
                                <td>{event.venueLocation}</td>
                                <td>{event.venueName}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={7} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="submit"
                onClick={() => {
                  // deleteNightshift()
                  setEventView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </React.Fragment>
  )
}

LeadMetrics.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  loading: PropTypes.bool,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeadMetrics)
)
